<template>
  <div v-if="showModal" class="side__modal opened">
    <div class="side__modal__content">
      <div class="modal__top">
        <div class="modal__header">
          <h3 class="modal__title">{{ $lang.app.REMARKS }}</h3>
          <span class="modal__close" @click="closeModal">
          <svg viewBox="0 0 20 20" width="20" height="20"><use xlink:href="@/assets/v2/img/sprite.svg#modal__close"></use></svg></span>
        </div>
      </div>

      <Form class="modal__footer"
            :validation-schema="schema"
            @submit="submit">

        <div class="input__group input__add__info">
          <label for="comment-input" class="label">{{ $lang.app.ACTION_REASON }}</label>
          <Field name="comment" v-slot="{ field, errorMessage }">
              <textarea v-bind="field"
                        id="comment-input"
                        v-model="form.comment"
                        class="input"
                        :class="{'input--fail': errorMessage }"
                        :placeholder="$lang.app.ENTER"/>
            <span v-if="errorMessage" class="input__fail">{{ errorMessage }}</span>
          </Field>
        </div>

        <div class="mb-5">
          <div class="flex justify-between items-baseline">
            <h4 class="tab__content__subtitle">{{ $lang.app.AGREEDS }}</h4>
            <button type="button"
                    @click="$emitter.emit('open-select-agreeds-modal', {agreeds: form.employments, withAccountant: false})">
              <svg class="icon" viewBox="0 0 24 24" width="24" height="24">
                <use xlink:href="@/assets/v2/img/sprite.svg#icon__edit"></use>
              </svg>
            </button>
          </div>
          <div class="block">
            <div v-for="(employment, index) in form.employments" :key="index" class="resolution__user" :title="employment.position">
              <div class="resolution__user__left">
                <div class="resolution__user__avatar">
                  <img src="@/assets/v2/img/user__avatar.jpg" alt="avatar" class="resolution__user__avatar__img">
                </div>
                <div class="resolution__user__info">
                  <div class="resolution__user__name">{{ employment.name }}</div>
                  <div class="resolution__user__rule">
                <span v-if="executorTypesGetValueByKey('CLOSING_SIGNER') === employment.type">
                  {{ $lang.app.CLOSING_SIGNER }}
                </span>
                  </div>
                </div>
              </div>
              <div class="resolution__user__right">
                <button type="button"
                        @click="removeEmployee(employment)" class="ml-1.5">
                  <svg class="icon" viewBox="0 0 24 24" width="24" height="24">
                    <use xlink:href="@/assets/v2/img/sprite.svg#icon__remove"></use>
                  </svg>
                </button>
              </div>
            </div>
          </div>
          <ErrorMessage name="employments" class="input__fail"/>
        </div>

        <div class="input__groups">
          <label for="files-input" class="label label__file mb-4 items-center">
            <span v-if="form.files.length">{{ form.files.map(item => item.name).join(', ') }}</span>
            <span v-else>
              <svg class="icon" viewBox="0 0 24 24" width="24" height="24">
                <use xlink:href="@/assets/v2/img/sprite.svg#icon__plus"></use>
              </svg>
              {{ $lang.app.ATTACH_FILES }}
              </span>
          </label>
          <Field type="file"
                 name="files"
                 multiple
                 accept="application/pdf,text/rtf,application/vnd.ms-excel,application/msword,image/jpeg,application/xml,application/rar,.rar"
                 id="files-input"
                 class="input__file hidden"
                 @change="event => form.files = [...event.target.files]"/>
          <ErrorMessage name="files" class="input__fail"/>
        </div>

        <div class="between__buttons">
          <button type="button" class="button button__modal__close button--cancel"
                  @click="closeModal">{{ $lang.app.CANCEL }}</button>
          <button type="submit" class="relative button button__modal__close"
                  :disabled="submitting">
            {{ $lang.app.SAVE }}
            <div v-if="submitting" class="loading-blue text-white absolute z-10 w-full rounded-lg h-full top-0 left-0 flex items-center justify-center">
              <div class="block animate-spin">
                <RefreshIcon class="w-6 h-6 mirror-y"/>
              </div>
            </div>
          </button>
        </div>
      </Form>
    </div>
  </div>
</template>
<script>
import {Field, Form, ErrorMessage} from 'vee-validate'
import * as yup from "yup";
import resolutionApi from "../../../../../api/employee/resolution";
import fileMixin from "../../../../../mixins/fileMixin";
import executorTypes, { getValueByKey as executorTypesGetValueByKey } from "../../../../../helpers/constants/executorTypes";

export default {
  props: {
    resolution: Object
  },
  components: {
    Field,
    Form,
    ErrorMessage,
  },
  mixins: [fileMixin],
  data() {
    return {
      showModal: false,
      submitting: false,
      form: {
        comment: '',
        employments: [],
        files: []
      },
      schema: yup.object({
        comment: yup.string().required()
      }),
    };
  },
  methods: {
    executorTypesGetValueByKey,
    openModal() {
      this.showModal = true
      this.$emitter.emit('body-unscrollable')
    },
    closeModal() {
      this.showModal = false
      this.$emitter.emit('body-scrollable')
    },
    initDefaultEmployments() {
      resolutionApi.defaultAgreementRemarksApproveSigners(this.resolution.id).then(res => {
        this.form.employments = res.map(item => ({
          id: item.id,
          name: item.name,
          position: this.$lang.$translate({ru: item.position.nameRu, kg: item.position.nameKg}),
          type: item.closingSign
              ? executorTypes.getValueByKey('CLOSING_SIGNER')
              : executorTypes.getValueByKey('SIGNER') ,
          vacation: item.activeVacation,
        }))
        this.$emitter.emit('select-agreeds-changed', this.form.employments)
      })
    },
    removeEmployee(employee) {
      this.form.employments = this.form.employments.filter(item => item.id !== employee.id)
      this.$emitter.emit('select-agreeds-changed', this.form.employments)
    },
    async submit() {
      this.submitting = true
      resolutionApi.agreementRemarks(this.resolution.id, {
        comment: this.form.comment,
        employments: this.form.employments.map(employee => ({
          employment: employee.id,
          type: employee.type,
        })),
        files: this.form.files ?
            await Promise.all(this.form.files.map(async file => ({
              filename: file.name,
              fileData: await this.getBase64(file)
            })))
            : null
      })
          .then(() => {
            this.closeModal()
            this.$emitter.emit('refresh-resolution')
            this.$emitter.emit('refresh-resolutions', {reload: false})
            this.$emitter.emit('refresh-application', {reload: false})
            this.$snotify.success(this.$lang.app.SUCCESS_ACTION)
          })
          .catch(error => {
            this.$snotify.error(error.response.data.message)
          }).finally(() => {
        this.submitting = false
      })
    }
  },
  beforeMount() {
    this.$emitter.on('open-agreement-remarks-modal', () => {
      this.initDefaultEmployments()
      this.openModal()
    })
    this.$emitter.on('agreeds-selected', (agreeds) => {
      this.form.employments = agreeds
    })
  },
  beforeUnmount() {
    this.$emitter.off('open-agreement-remarks-modal')
    this.$emitter.off('agreeds-selected')
  }
}
</script>
